import { createFileRoute } from '@tanstack/react-router';
import CandidateMailTemplateFormTemplate from '@/features/agent/candidate_mails/templates/CandidateMailTemplateFormTemplate';

export const Route = createFileRoute('/agent/candidate_mails/templates/$templateId/edit')({
  component: RouteComponent,
  staticData: { title: 'テンプレート編集' },
});

function RouteComponent() {
  const { templateId } = Route.useParams();
  return <CandidateMailTemplateFormTemplate templateId={Number(templateId)} />;
}
